<script lang="ts">
  import { findErrorMessage } from '@astlai/common/util/error-handling/find-error-message';
  import { onMount } from "svelte";

  interface Props {
    error: any;
  }

  let { error }: Props = $props();

  const parsedError = $derived(findErrorMessage(error));

  const RELOAD_ATTEMPTED_KEY = "error_reload_attempted";

  onMount(() => {
    const status = error?.status;
    if (status && status >= 500 && status < 600) {
      const hasReloadedBefore = sessionStorage.getItem(RELOAD_ATTEMPTED_KEY);

      if (!hasReloadedBefore) {
        sessionStorage.setItem(RELOAD_ATTEMPTED_KEY, "true");
        window.location.reload();
      }
    }
  });
</script>

<div class="error-box">
  <span>Error: {parsedError}</span>
</div>

<style lang="scss">
  @use "@astlai/common/styles/mixins" as lib;

  .error-box {
    backdrop-filter: blur(10px);
    font-size: 0.875rem;
    color: var(--text-error);
    background: var(--surface-error);
    padding: 1rem;
    border-radius: 0.5rem;
    white-space: pre-line;
  }
</style>
